// Environment
export const ENVIRONMENT = process.env.NODE_ENV === 'production' ? '' : 'https://note-desenv13';

// Base name
export const BASE_NAME = process.env.NODE_ENV === 'production' ? '/DiplomaDigital' : '';

// Webservices URLs
export const URL_DIPLOMA = ENVIRONMENT + '/DiplomaDigital/rs/diploma-digital';
export const URL_HISTORICO = ENVIRONMENT + '/DiplomaDigital/rs/historico-parcial';
export const URL_DIPLOMA_ALUNO = URL_DIPLOMA + '/aluno';
export const URL_HISTORICO_ALUNO = URL_HISTORICO + '/aluno';

// Message types
export const MESSAGE_INFO = 'info';
export const MESSAGE_ALERT = 'warning';
export const MESSAGE_ERROR = 'error';
export const MESSAGE_SUCCESS = 'success';

export const GOOGLE_RECAPTCHA_KEY = '6Ld1OKAfAAAAAOKnEFePzfusMdMcP4FHA2KTgRPZ';